import { stateMapByStateName } from './constants';
import { toProperCase } from './util';

const countiesByState = {
  GA: [
    'Appling County',
    'Atkinson County',
    'Bacon County',
    'Baker County',
    'Baldwin County',
    'Banks County',
    'Barrow County',
    'Bartow County',
    'Ben Hill County',
    'Berrien County',
    'Bibb County',
    'Bleckley County',
    'Brantley County',
    'Brooks County',
    'Bryan County',
    'Bulloch County',
    'Burke County',
    'Butts County',
    'Calhoun County',
    'Camden County',
    'Candler County',
    'Carroll County',
    'Catoosa County',
    'Charlton County',
    'Chatham County',
    'Chattahoochee County',
    'Chattooga County',
    'Cherokee County',
    'Clarke County',
    'Clay County',
    'Clayton County',
    'Clinch County',
    'Cobb County',
    'Coffee County',
    'Colquitt County',
    'Columbia County',
    'Cook County',
    'Coweta County',
    'Crawford County',
    'Crisp County',
    'Dade County',
    'Dawson County',
    'Decatur County',
    'DeKalb County',
    'Dodge County',
    'Dooly County',
    'Dougherty County',
    'Douglas County',
    'Early County',
    'Echols County',
    'Effingham County',
    'Elbert County',
    'Emanuel County',
    'Evans County',
    'Fannin County',
    'Fayette County',
    'Floyd County',
    'Forsyth County',
    'Franklin County',
    'Fulton County',
    'Gilmer County',
    'Glascock County',
    'Glynn County',
    'Gordon County',
    'Grady County',
    'Greene County',
    'Gwinnett County',
    'Habersham County',
    'Hall County',
    'Hancock County',
    'Haralson County',
    'Harris County',
    'Hart County',
    'Heard County',
    'Henry County',
    'Houston County',
    'Irwin County',
    'Jackson County',
    'Jasper County',
    'Jeff Davis County',
    'Jefferson County',
    'Jenkins County',
    'Johnson County',
    'Jones County',
    'Lamar County',
    'Lanier County',
    'Laurens County',
    'Lee County',
    'Liberty County',
    'Lincoln County',
    'Longs County',
    'Lowndes County',
    'Lumpkin County',
    'Macon County',
    'Madison County',
    'Marion County',
    'McDuffie County',
    'McIntosh County',
    'Meriwether County',
    'Miller County',
    'Mitchell County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Murray County',
    'Muscogee County',
    'Newton County',
    'Oconee County',
    'Oglethorpe County',
    'Paulding County',
    'Peach County',
    'Pickens County',
    'Pierce County',
    'Pike County',
    'Polk County',
    'Pulaski County',
    'Putnam County',
    'Quitman County',
    'Rabun County',
    'Randolph County',
    'Richmond County',
    'Rockdale County',
    'Schley County',
    'Screven County',
    'Seminole County',
    'Spalding County',
    'Stephens County',
    'Stewart County',
    'Sumter County',
    'Talbot County',
    'Taliaferro County',
    'Tattnall County',
    'Taylor County',
    'Telfair County',
    'Terrell County',
    'Thomas County',
    'Tift County',
    'Toombs County',
    'Towns County',
    'Treutlen County',
    'Troup County',
    'Turner County',
    'Twiggs County',
    'Union County',
    'Upson County',
    'Walker County',
    'Walton County',
    'Ware County',
    'Warren County',
    'Washington County',
    'Wayne County',
    'Webster County',
    'Wheeler County',
    'White County',
    'Whitfield County',
    'Wilcox County',
    'Wilkes County',
    'Wilkinson County',
    'Worth County',
  ],
};

export default function getCountiesForState(state) {
  let counties = [];
  if (countiesByState[state.toUpperCase()]) {
    counties = countiesByState[state];
  }

  if (state.length > 2) {
    const stateFullName = toProperCase(state);
    if (countiesByState[stateMapByStateName[stateFullName]]) {
      counties = countiesByState[stateMapByStateName[stateFullName]];
    }
  }
  return counties;
}
